<div class="base-container">
    <div class="container">
        <div class="details">
            <router-outlet></router-outlet>
        </div>

        <div class="footer">
            <div (click)="scrollToTop()" class="container">
                <i class="fa fa-chevron-up"></i>
                Zurück nach oben
            </div>
        </div>
    </div>
</div>

<bd-modal #modal class="info-modal" [title]="modalService.getTitle()" [closable]="false">
    <div class="text">
        {{ modalService.getContent() }}
    </div>
    <button (click)="modal.close()">Verstanden</button>
</bd-modal>


<!-- #folderModal is used to edit bookmarks(organized by folders) and can be opened fromm product
     detail for example to add product to bookmark folder -->
<bd-modal #folderModal [closable]="true" class="folder-modal" title="Zur Merkliste">
    <div class="header">
        <div class="title">
            Zur neuen Merkliste hinzufügen
        </div>
        <div class="action">
            <input [(ngModel)]="newFolderName"/>
            <button [disabled]="!canAddToNewFolder()" (click)="addToNewFolder()">Hinzufügen</button>
        </div>
    </div>
    <bd-hr>oder</bd-hr>
    <div class="content">
        <div class="title">
            Zur bestehenden Merkliste hinzufügen
        </div>
        <div class="bookmarks">
            <div *ngFor="let folder of folderService.folders" (click)="addToFolder(folder.id)" class="row">
                <div class="name">
                    {{ folder.name }}
                </div>
                <div class="count">
                    {{
                        folder.productCount === 0 ? 'Keine Produkte' : folder.productCount + ' Produkt' + (folder.productCount > 1
                            ?
                            'e' : '')
                    }}
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>
        </div>
    </div>
</bd-modal>
